import { memo, useEffect, useState } from 'react'

import { IContactFlag } from 'clickNgo/entities/contactFlag'
import { SimpleTable } from 'cng-common/components/simpleTable'
import { Input } from 'core-components/library/inputs'

import styles from './ContactDetailsFlags.module.scss'

interface Props {
  contactFlags: IContactFlag[]
  title: string
}

export const ContactDetailsFlags = memo<Props>(({ contactFlags = [], title }) => {
  const [searchQuery, setSearchQuery] = useState('')
  const [filteredFlags, setFilteredFlags] = useState<IContactFlag[]>([])

  useEffect(() => {
    setFilteredFlags(
      contactFlags.filter((flag) => flag.code.toLowerCase().includes(searchQuery.toLowerCase()))
    )
  }, [contactFlags, searchQuery])

  return (
    <div className={styles.contactDetailsWrapper}>
      <SimpleTable className={styles.contactDetailsTable}>
        <SimpleTable.HeaderRow className={styles.contactDetailsTableHeaderRow}>
          <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
            Contact flags: {title}
          </SimpleTable.HeaderCell>
        </SimpleTable.HeaderRow>
        <SimpleTable.HeaderRow>
          <SimpleTable.HeaderCell className={styles.searchInput}>
            <Input placeholder="Search" onChange={setSearchQuery} />
          </SimpleTable.HeaderCell>
        </SimpleTable.HeaderRow>
        {filteredFlags.map((flag) => (
          <SimpleTable.BodyRow key={flag.code} className={styles.contactDetailsTableBodyRow}>
            <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
              {flag.code}
            </SimpleTable.BodyCell>
          </SimpleTable.BodyRow>
        ))}
      </SimpleTable>
    </div>
  )
})
